var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"animate"}},[_c('div',{staticClass:"g pop-up"},[_c(_vm.computedType,{tag:"component",attrs:{"content":_vm.content,"sn":_vm.sn},on:{"sendEvent":_vm.receiveEvent}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }